import { render, staticRenderFns } from "./pay_password.vue?vue&type=template&id=0d12d8d6&scoped=true&"
import script from "./pay_password.vue?vue&type=script&lang=js&"
export * from "./pay_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12d8d6",
  null
  
)

export default component.exports